module.exports = __webpack_public_path__ + "img/Hawaii Outline.05db40d4.png";